import Prismic from '@prismicio/client'
import createModule from '@/store/createModule'

export default (store) => {
  createModule(
    store,
    'prismic',
    {
      navigationData: null,
      seasonalMarketData: null,
      shippingData: null,
      shippingTimelines: null,
      orderSummaryData: null,
      customizeLandingPageData: null,
      customizeReviewPageData: null,
      subscriptionBoxandPlan: null,
      globalElementsData: null,
      homeBannerData: null,
      promoBannerData: null,
      sendABoxData: null,
      accountSettingsData: null,
      marketLandingData: null,
      marketCollectionPillsData: null,
      cancellationSurveyData: null,
    },
    {
      getters: ({ get }) => ({
        getNavigationItemText() {
          return (primaryType) =>
            get('navigationData')?.find((data) => data.primary.type === primaryType)?.primary
              .navigation_item[0].text
        },
        getSubscribeBoxAndPlansCards: (state) => (type) => {
          return state.subscriptionBoxandPlan?.body
            ?.filter((data) => data.primary?.product_code === type)
            ?.filter((data) => data.slice_type === 'subscription_product_card')
        },
        getSubscribeBoxAndPlansData() {
          return (type) => {
            const data = get('subscriptionBoxandPlan')?.body.find(
              (data) => data.primary.product_code === type
            )
            return data?.primary
          }
        },
        getSubscribeBoxAndPlans() {
          return get('subscriptionBoxandPlan')?.body
        },
        getSubscribePageData() {
          return get('subscriptionBoxandPlan')
        },
        // getSubscribeBoxAndPlansByPlanCode: (state) => (planCode) => {
        //   if (!state.subscriptionBoxandPlan) {
        //     return []
        //   }

        //   // Loop through all products in subscriptionBoxandPlan
        //   const mappedWithFilteredSlices = state.subscriptionBoxandPlan?.body.map((data) => {
        //     // Filter by slice_type first
        //     if (data.slice_type !== 'subscription_product_card') {
        //       return [] // Skip if slice_type doesn't match
        //     }

        //     // Ensure items is an array before filtering
        //     if (!Array.isArray(data.items)) {
        //       return [] // Return an empty array if items is not an array
        //     }

        //     // Loop through each item and check if its plan_code matches the provided planCode
        //     const filteredSlices = data.items?.filter((item) => {
        //       if (item.plan_code === undefined) {
        //         return false // Exclude items without plan_code
        //       }
        //       return item.plan_code === planCode // Match plan_code
        //     })

        //     return filteredSlices.length > 0 ? filteredSlices : []
        //   })

        //   // Flatten the result and return the filtered items
        //   return mappedWithFilteredSlices?.flat() || []
        // },
        getShippingData() {
          return get('shippingData')
        },
        getShippingTimelineData() {
          return (type) =>
            get('shippingTimelines')?.find((data) => data.primary.type === type)?.primary
        },
        getOrderSummaryData() {
          return (type) =>
            get('orderSummaryData')?.find((data) => data.primary.type === type)?.primary.copy
        },
        getSendABoxData() {
          return get('sendABoxData')
        },
      }),

      mutations: () => ({
        setNavigationData(state, navigationData) {
          state.navigationData = navigationData
        },
        setSeasonalMarketData(state, seasonalMarketData) {
          state.seasonalMarketData = seasonalMarketData
        },
        setShippingData(state, shippingData) {
          state.shippingData = shippingData
        },
        setSubscriptionBoxandPlan(state, subscriptionBoxandPlan) {
          state.subscriptionBoxandPlan = subscriptionBoxandPlan
        },
        setShippingTimelinesData(state, shippingTimelines) {
          state.shippingTimelines = shippingTimelines
        },
        setOrderSummaryData(state, orderSummaryData) {
          state.orderSummaryData = orderSummaryData
        },
        setCustomizeLandingPageData(state, customizeLandingPageData) {
          state.customizeLandingPageData = customizeLandingPageData
        },
        setCustomizeReviewPageData(state, customizeReviewPageData) {
          state.customizeReviewPageData = customizeReviewPageData
        },
        setGlobalElementsData(state, globalElementsData) {
          state.globalElementsData = globalElementsData
        },
        setHomeBannerData(state, homeBannerData) {
          state.homeBannerData = homeBannerData
        },
        setAccountSettingsData(state, accountSettingsData) {
          state.accountSettingsData = accountSettingsData
        },
        setPromoBannerData(state, promoBannerData) {
          state.promoBannerData = promoBannerData
        },
        setSendABoxData(state, sendABoxData) {
          state.sendABoxData = sendABoxData
        },
        setMarketLandingData(state, marketLandingData) {
          state.marketLandingData = marketLandingData
        },
        setMarketCollectionPillsData(state, data) {
          state.marketCollectionPillsData = data
        },
        setCancellationSurveyData(state, data) {
          state.cancellationSurveyData = data
        },
      }),

      actions: ({ set }) => ({
        async loadNavigationData() {
          const response = await Prismic.client.getByUID('navigation', 'navigation-header')
          set('setNavigationData', response.data.body)
        },
        async loadSeasonalMarketData() {
          const response = await Prismic.client.getByUID('page', 'seasonal-market')
          set('setSeasonalMarketData', response.data.body[0].primary)
        },
        async loadSubscriptionBoxandPlan() {
          const response = await Prismic.client.getByUID(
            'subscription_product_info',
            'subscription_box_and_plan'
          )
          set('setSubscriptionBoxandPlan', response.data)
        },
        async loadShippingTimelines() {
          const response = await Prismic.client.getByUID(
            'shipping_timelines_modal',
            'shipping-timelines'
          )
          set('setShippingData', response.data)
          set('setShippingTimelinesData', response.data.body)
        },
        async loadOrderSummaryData() {
          const response = await Prismic.client.getByUID('order_summary', 'order_summary')
          set('setOrderSummaryData', response.data.body)
        },
        async loadCustomizeLandingPageData() {
          const response = await Prismic.client.getByUID('page', 'customize_landing_page')
          set('setCustomizeLandingPageData', response.data.body[0].primary)
        },
        async loadCustomizeReviewPageData() {
          const response = await Prismic.client.getByUID('page', 'customize-review-page')
          const mappedData = response.data.body.map((body) => body.primary)
          set('setCustomizeReviewPageData', mappedData)
        },
        async loadGlobalElementsData() {
          const response = await Prismic.client.getByUID('global_elements', 'global-elements')
          set('setGlobalElementsData', response.data)
        },
        async loadHomeBannerData() {
          const response = await Prismic.client.getByUID('home_banner', 'home_banner')
          set('setHomeBannerData', response.data)
        },
        async loadAccountSettingsData() {
          const response = await Prismic.client.getByUID(
            'account_settings_page',
            'account-settings'
          )
          set('setAccountSettingsData', response.data)
        },
        async loadPromoBannerData() {
          const response = await Prismic.client.getByUID('promo_header_banner', 'promo_banner')
          set('setPromoBannerData', response.data)
        },
        async loadSendABoxData() {
          const response = await Prismic.client.getByUID(
            'send_a_box_landing_page',
            'send_a_box_landing'
          )
          set('setSendABoxData', response.data)
        },
        async loadMarketCollectionPillsData() {
          try {
            const response = await Prismic.client.getByUID('page', 'seasonal-market')
            const slice = response.data.body.find((s) => s.slice_type === 'collections_pills')
            set('setMarketCollectionPillsData', slice?.items || null)
          } catch (e) {
            set('setMarketCollectionPillsData', [])
          }
        },
        async loadCancellationSurveyData() {
          try {
            const response = await Prismic.client.getSingle('cancellation_survey')
            set('setCancellationSurveyData', response.data.body)
          } catch {
            // Fail silently — component falls back to hardcoded questions
          }
        },
        async loadMarketLandingData() {
          try {
            const response = await Prismic.client.getByUID(
              'market_landing_page',
              'market-landing'
            )
            set('setMarketLandingData', response.data)
          } catch (e) {
            // Prismic document may not exist yet — page falls back to hardcoded content
          }
        },
      }),
    }
  )
}
